import { SVGProps } from 'react'

const Morpho = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1019_4813)">
      <path
        d="M1.88892 10.6785V15.0212C1.88892 15.2885 2.11517 15.3995 2.18555 15.4247C2.25594 15.4549 2.49224 15.5205 2.7034 15.3238L5.98866 12.1667C6.26843 11.8979 6.53844 11.6153 6.74135 11.2846C6.83685 11.1292 6.87644 11.0416 6.87644 11.0416C7.07757 10.6331 7.07757 10.2397 6.88141 9.84623C6.58992 9.26116 5.84575 8.66598 4.72452 8.10107L2.80899 9.17037C2.24087 9.49318 1.88892 10.0631 1.88892 10.6785Z"
        fill="#00378A"
      />
      <path
        d="M0 1.01957V5.57413C0 6.14407 0.382115 6.64845 0.925118 6.80985C2.77532 7.34449 5.99809 8.49447 6.77741 10.1842C6.87788 10.4061 6.93824 10.623 6.95848 10.8499C7.47631 9.90674 7.71259 8.82232 7.60199 7.72277C7.4511 6.16424 6.62651 4.74693 5.33948 3.84409L0.749142 0.631195C0.668689 0.570669 0.573164 0.540405 0.477639 0.540405C0.397187 0.540405 0.3268 0.555537 0.251388 0.595888C0.100548 0.681632 0 0.837993 0 1.01957Z"
        fill="#2E4DFF"
      />
      <path
        d="M14.108 10.6785V15.0212C14.108 15.2885 13.8818 15.3995 13.8113 15.4247C13.741 15.4549 13.5046 15.5205 13.2935 15.3238L9.93177 12.0933C9.70294 11.8733 9.48441 11.6407 9.31204 11.3742C9.17552 11.1632 9.12049 11.0416 9.12049 11.0416C8.91936 10.6331 8.91936 10.2397 9.11534 9.84623C9.40701 9.26116 10.1512 8.66598 11.2722 8.10107L13.1879 9.17037C13.7611 9.49318 14.108 10.0631 14.108 10.6785Z"
        fill="#00378A"
      />
      <path
        d="M16 1.0192V5.57375C16 6.1437 15.6178 6.64807 15.0748 6.80948C13.2246 7.34412 10.0019 8.49412 9.22258 10.1838C9.12193 10.4057 9.06157 10.6226 9.04151 10.8496C8.52368 9.90639 8.2874 8.82196 8.39799 7.72241C8.54871 6.16387 9.3733 4.74657 10.6605 3.84374L15.2509 0.630827C15.3313 0.570301 15.4268 0.540039 15.5223 0.540039C15.6027 0.540039 15.6732 0.555171 15.7485 0.595521C15.8994 0.681266 16 0.837625 16 1.0192Z"
        fill="#2E4DFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1019_4813">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default Morpho
